module.exports = __webpack_public_path__ + "img/3bhk-b1.3907101d.jpg";